import { Component, OnInit, Input } from '@angular/core';
import { Item } from 'my-lib-sanfelici/my-lib-sanfelici';

@Component({
  selector: 'app-dreams-view',
  templateUrl: './dreams-view.component.html',
  styleUrls: ['./dreams-view.component.scss']
})
export class DreamsViewComponent implements OnInit {
  @Input() items: Item[];
  constructor() { }

  ngOnInit() {
  }

}
